import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "people-connections-timeline",
  courseId: "investigations",
  order: 9,
  title: "People and timeline",
  subtitle: "Plus connections",
  summary:
    "Entities are extracted from every source, a 3D graph shows who talks about whom, and the timeline orders events by when they happened, not when you uploaded them.",
  learn: [
    "Rename and merge entities on the Mentions tab",
    "Read the connections graph",
    "Annotate and hide timeline entries without touching the AI text",
  ],
  minutes: 4,
  releasedAt: "2026-09-15T00:00:00.000Z",
  gate: "investigations",
  body: [
    { type: "heading", text: "Mentions" },
    {
      type: "paragraph",
      text: "The same person shows up as \"Marc\", \"Marcus\", and \"M\" across a month of calls. The Mentions tab is where you tell the AI they are one person.",
    },
    {
      type: "steps",
      items: [
        "Open the Mentions tab. People, places, phones, vehicles, weapons, and items are listed with mention counts and aliases.",
        "Click **Rename** to give a nickname its real name.",
        "Click **Merge** when two entries are the same person.",
        "Click an entity to see every mention with its source.",
      ],
    },
    {
      type: "paragraph",
      text: "Merged entities stay merged through later uploads.",
    },
    { type: "heading", text: "Connections" },
    {
      type: "paragraph",
      text: "The connections view draws entities as a 3D graph with edges for co-mention. Drag to rotate, scroll to zoom, and click a node to focus on it. Edges are computed when you open it, so it reflects your renames and merges immediately.",
    },
    { type: "heading", text: "Timeline" },
    {
      type: "paragraph",
      text: "Calls sit at their call time, documents at their earliest key date, spreadsheets across their date span, and brief entries at the date the AI assigned.",
    },
    {
      type: "steps",
      items: [
        "Open the Timeline tab.",
        "Hover an entry to open the kebab menu: Open source, Add note, or Hide.",
        "To bring back hidden entries, use the \"Hidden (N)\" toggle.",
        "To export the tab, use **Export** then Timeline, with filters for calls, flags, files, and brief entries.",
      ],
    },
    {
      type: "paragraph",
      text: "Notes show your name.",
    },
    {
      type: "callout",
      tone: "note",
      text: "Hiding and annotating never edit the AI's text, and they survive brief regeneration. The discovery package carries the full timeline, hidden items included, so nothing disappears from the record.",
    },
  ],
  related: ["read-the-brief", "documents-spreadsheets-photos", "export-and-discovery"],
};

export default lesson;
